import { render, staticRenderFns } from "./LegalEntityFormModal.vue?vue&type=template&id=b93a7022&"
import script from "./LegalEntityFormModal.vue?vue&type=script&lang=js&"
export * from "./LegalEntityFormModal.vue?vue&type=script&lang=js&"
import style0 from "./LegalEntityFormModal.vue?vue&type=style&index=0&id=b93a7022&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports